module.exports = __webpack_public_path__ + "static/img/success.336a89c0.png";